import QRCode from "qrcode";

export function generateQrDataUrl(text, options = {}) {
  return QRCode.toDataURL(String(text || ""), {
    errorCorrectionLevel: "M",
    margin: 2,
    width: 280,
    color: {
      dark: "#000000",
      light: "#ffffff",
    },
    ...options,
  });
}
